<template>
  <section>
    <el-form :model="formModel" label-position="left" class="info-form">
      <el-row v-for="(row, rowIndex) in formFields" :key="rowIndex" :gutter="30">
        <el-col v-for="(field,colIndex) in row" :key="field.label" :span="colIndex === 1 ? 10 : 7">
          <el-form-item :label="field.label">
            <span v-if="field.prop==='orderId'" class="primary cur" @click="toOrderDetail(formModel)">{{ formModel[field.prop] }}</span>
            <span v-else-if="field.prop==='lineName'" class="primary cur" @click="toLineDetail(formModel)">{{ formModel[field.prop] }}</span>
            <span v-else>{{ formModel[field.prop] }}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-radio-group v-model="tableData.chooseRadio">
          <el-table
              v-loading="tableData.loading"
              ref="multipleTable"
              :data="tableData.data"
              tooltip-effect="dark"
              height="300"
              @select="handleSelectionChange"
              @select-all="handleSelectionChange"
              @row-click="handleRowClick"
          >
            <!-- 选择框 -->
            <el-table-column v-if="!isRadio" type="selection" width="55" />
            <el-table-column v-if="isRadio" width="55" label="选择">
              <template slot-scope="scope">
                <el-radio :label="scope.row[tableData.selectTar]"
                >&nbsp;</el-radio
                >
              </template>
            </el-table-column>
            <!-- 选择框 end -->
            <!-- 常规列表项 -->
            <template v-for="(item, index, key) in tableData.title">
              <el-table-column
                  :key="key"
                  :prop="item.prop"
                  :label="item.label"
                  :sortable="item.sortable"
                  :filters="item.filters"
                  :filter-method="item.filterHandler"
                  :min-width="item.minW"
                  :width="item.w"
              >
                <section slot-scope="scope">
                  <!-- 订单号码 -->
                  <section v-if="scope.column.property === 'orderId'">
                    <span class="primary cur" @click="toOrderDetail(scope.row)">{{
                        scope.row[scope.column.property]
                      }}</span>
                  </section>
                  <!-- 线路名称 -->
                  <section
                      v-else-if="scope.column.property === 'lineName'"
                  >
                    <span
                        :class="{
                        primary: scope.row.lineId !== -1 && scope.row.lineId !==null,
                        cur: scope.row.lineId !== -1 && scope.row.lineId !==null,
                      }"
                        @click="toLineDetail(scope.row)"
                    >{{
                        scope.row[scope.column.property]
                      }}
                    </span>
                  </section>
                  <!-- 线路名称 end -->
                  <!-- 订单号码 end -->
                  <section v-else>{{ scope.row[scope.column.property] }}</section>
                </section>
              </el-table-column>
            </template>
            <!-- 常规列表项 end -->
          </el-table>
        </el-radio-group>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="tableData.page"
              :page-sizes="[10, 30, 50]"
              :page-size="tableData.count"
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </section>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import { queryMatchOrders} from 'api/operate';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
  },
  props: {
    isRadio: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      formModel: {
        orderId: '',
        lineName: '',
        driverName: '',
        plateNumber: '',
        loadingTime: '',
        orderSource: '',
      },
      formFields: [
        [
          { label: '订单号', prop: 'orderId' },
          { label: '线路名称', prop: 'lineName' },
          { label: '司机名称', prop: 'driverName' },
        ],
        [
          { label: '车牌号', prop: 'plateNumber' },
          { label: '装货时间', prop: 'loadingTime' },
          { label: '数据来源', prop: 'orderSource' },
        ],
      ],
      formData: {
        inline: true,
        form: [
          {
            label: '订单号',
            value: 'orderId',
            type: 'show',
          },
          {
            label: '线路名称',
            value: 'lineName',
            type: 'show',
          },
          {
            label: '司机名称',
            value: 'driverName',
            type: 'show',
          },
          {
            label: '车牌号',
            value: 'plateNumber',
            type: 'show',
          },
          {
            label: '装货时间',
            value: 'loadingTime',
            type: 'show',
          },
          {
            label: '数据来源',
            value: 'orderSource',
            type: 'show',
          },


        ],
      },
      tableData: { // 表格相关数据
        loading: false,
        count: 20,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        selectTar: 'orderId',
        chooseRadio: '', // 单选选择
        title: [ // 表头
          {prop: 'orderId', label: '订单号'},
          {prop: 'lineName', label: '线路名称'},
          {prop: 'driverName', label: '司机名称'},
          {prop: 'driverPhone', label: '司机账号'},
          {prop: 'plateNumber', label: '车牌号'},
          {prop: 'loadingTime', label: '装货时间'},

        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: queryMatchOrders,
    handleRowClick (item) {
      this.tableData.chooseRadio = item[this.tableData.selectTar];
    },
    toOrderDetail (item) {
      this.$emit('closeModal');
      this.jump({
        label: `订单详情-${item.orderId}`,
        url: `/manage/operate/dzOrder/dzOrderlist/detail?orderId=${item.orderId}`,
        full: true,
      });
    },
    toLineDetail (item, type = '') {
      this.$emit('closeModal');
      if (item.lineId === -1 || item.lineId === null) {
        return;
      }
      this.jump({
        label: '线路详情',
        url: `/manage/archives/customer/line/detail?id=${item.lineId}&type=${type}`,
        full: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.info-form {
  padding:10px;
  ::v-deep .el-form-item__content {
    padding: 0;
  }
}
</style>
